import { AcoesPlanejamentoOficina } from "./acoes-planejamento-oficinas";
import { MaterialPlanejamentoOficina } from "./materiais-planejamento-oficina";
import { Percurso } from "./percurso";
import { Programa } from './programa';
import { Projeto } from './projeto';
import { PublicoAlvoPlanejamentoOficina } from "./publico-alvo-planejamento-oficina";
import { TurmaPlanejamentoOficina } from "./turma-planejamento-oficina";
import { Unidade } from './unidade';
import { Usuario } from "./usuario";

export class PlanejamentoOficina {
    id: number;
    descricao: string;
    dataPrevisaoInicio: Date;
    dataPrevisaoFim: Date;
    dataInicio: Date;
    dataFim: Date;
  
    segunda: string;
    terca: string;
    quarta: string;
    quinta: string;
    sexta: string;
    sabado: string;
    domingo: string;
  
    horaInicio: number;
    horaFim: number;
    maximoParticipantes: number;
    cargaHoraria: number;
  
    localExecucao: string;
    descricaoMetodologia: string;
    observacoes: string;
  
    unidade: Unidade;
    programa: Programa;
    projeto: Projeto;
    quantidadeParticipantes: number;
    percurso: Percurso;
  
    descricaoApontamentos: string;
    descricaoPublicoAlvo: string;
    descricaoLocalExecucao: string;
    area: string;
    atividadeAprovada: Boolean;
    dataAprovacaoAtividade: Date;
  
    materiaisPlanejamentosOficinas: MaterialPlanejamentoOficina[];
    turmasPlanejamentosOficinas: TurmaPlanejamentoOficina[];
    publicosAlvosPlanejamentoOficina: PublicoAlvoPlanejamentoOficina[];
    acoesPlanejamentoOficina: AcoesPlanejamentoOficina[];
    usuarioAplicacao: Usuario;
  }